import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class UpdateTypeDocumentRequest extends GenericRequest {

    document;

    constructor(documentId, document) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.DOCUMENT_TYPE_ID, { id: documentId }));
        this.document = document;
    }

    overrideRequest() {
        let request = {};
        if ( this.document ) request = { ...request, ...this.document };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/UpdateTypeDocumentRequest.js